import { useEffect, useRef, useState } from "react";
import "./App.css";
import { Contents, Header, Top } from "../features/landing";
import SplashScreen from "../features/landing/components/SplashScreen/SplashScreen";
import bg1 from "../assets/background/kmweb_bg01.jpg";
import bg2 from "../assets/background/kmweb_bg02.jpg";
import bg3 from "../assets/background/kmweb_bg3.jpg";
import bg4 from "../assets/background/kmweb_bg04.jpg";
import ConceptPage from "../features/landing/components/Concept/Concept";
import { Menus } from "../features/landing/components/Menus/Menus";
import { Event } from "../features/landing/components/Event/Event";
import Access from "../features/landing/components/Access/Access.tsx";
import Reservation from "../features/landing/components/Reservation/Reservation";
import ShoppingCart from "../features/landing/components/Top/components/ShoppingCart/ShoppingCart";
import { Routes, Route, Navigate } from 'react-router-dom';
import OurThoughts from "../features/landing/components/OurThoughts/OurThoughts";
import LunchMenuPage from "../features/landing/components/MenuPage/lunch/LunchMenuPage.tsx";
import Layout from "./components/Layout";
import DinnerMenuPage from "../features/landing/components/MenuPage/dinner/DinnerMenuPage.tsx";
import TakeoutMenuPage from "../features/landing/components/MenuPage/takeout/TakeoutMenuPage.tsx";
import { EnzymeBrownRice } from "../features/landing/components/EnzymeBrownRice/EnzymeBrownRice";

const LandingPage = () => {
  const [showSplash, setShowSplash] = useState(true);
  const [showTitle, setShowTitle] = useState(false);
  const [isHeaderVisible, setIsHeaderVisible] = useState(false);
  const topRef = useRef<HTMLDivElement | null>(null);
  const [isTopVisible, setIsTopVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
      setTimeout(() => {
        setShowTitle(true);
      }, 1000);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!topRef.current) return;

    const callback: IntersectionObserverCallback = ([entry]) => {
      setIsTopVisible(entry.isIntersecting);
      setIsHeaderVisible(!entry.isIntersecting);
    };

    const options: IntersectionObserverInit = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver(callback, options);
    observer.observe(topRef.current);

    return () => {
      if (topRef.current) {
        observer.unobserve(topRef.current);
      }
    };
  }, []);

  return (
    <>
      {showSplash ? (
        <SplashScreen />
      ) : (
        <>
          <Header />
          <ShoppingCart />
          <div ref={topRef}>
            <Top
              images={[bg2, bg3, bg4, bg1]}
              isTopVisible={isTopVisible}
              isHeaderVisible={isHeaderVisible}
              showTitle={showTitle}
            />
          </div>
          
          <ConceptPage />
          <Menus />
          <Event />
          <Access />
          <Reservation />
          <Contents />
        </>
      )}
    </>
  );
};

const App = () => {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/ourthoughts" element={<OurThoughts />} />
        <Route path="/lunchmenu" element={<LunchMenuPage />} />
        <Route path="/dinnermenu" element={<DinnerMenuPage />} />
        <Route path="/takeoutmenu" element={<TakeoutMenuPage />} />
        <Route path="/brownrice" element={<EnzymeBrownRice />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
};

export default App;
